// extracted by mini-css-extract-plugin
export default {"main":"style_main__s7a5e","catalogContainer":"style_catalogContainer__5EoX9"};